/* RESPONSIBLE TEAM: team-frontend-tech */
import relativeTime from 'embercom/lib/relative-time';

let abbreviatedRelativeTime = function (dateString) {
  return relativeTime(dateString, 'en-abbreviated-relative-time');
};

export default abbreviatedRelativeTime;
